// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FyXXv,\n.FyXXv:hover {\n  background-color: transparent;\n}\n\n.FyXXv {\n  font-size: unset;\n}\n\n.rF929 {\n  padding: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "FyXXv",
	"noPadding": "rF929"
};
export default ___CSS_LOADER_EXPORT___;
